import { MAX_IMAGE_SIZE, MAX_VIDEO_SIZE, MIN_IMAGE_SIZE } from "../constants/constants";
import { LOG_TYPE } from './constant';
import axios from 'axios';
import { ToastError } from "../components/toastify";
import moment from "moment";
import CryptoJS from 'crypto-js';


const NOTIFICATION_SERVICE = process.env.REACT_APP_NOTIFICATION_SERVICE;
const jwtTokenKey = process.env.REACT_APP_SECRET_JWT_TOKEN_KEY;

export const getAcedYear = () => {
  let userDetail = JSON.parse(localStorage.getItem('auth-user'))
  return userDetail?.academicYear;
}

export const debounce = (func) => {
  let timer;
  return function (...args) {
    const context = this;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      func.apply(context, args);
    }, 500);
  };
};

export const reload = () => window.location.reload();

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const validatePassword = (password) => {
  return (/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=]).{8,}$/).test(password)

}
export const validateWholeNumber = (number) => {
  return (/^[0-9]+$/).test(number)

}

export const createImageUrl = (file) => {
  return URL.createObjectURL(file);
}

export const fileSizeValidations = (file, fileType) => {
  const fSize = file.size;
  const selectedFile = Math.round((fSize / 1024));
  if (fileType === 'image') {
    if (selectedFile >= MIN_IMAGE_SIZE && selectedFile <= MAX_IMAGE_SIZE) {
      return true
    }
  } else if (fileType === 'video') {
    if (selectedFile <= MAX_VIDEO_SIZE) return true
  }
  else if (fileType === 'pdf') {

  }
  return false
}

export const reArrangeOrder = (list) => {
  let arr = [];
  for (let item of list) {
    arr.push(item.id || item?.menuId)
  }
  return arr;
}

export const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

export const todayDate = () => {
  const date = new Date();
  const day = date.getDate();
  let month = date.getMonth() + 1;
  const year = date.getFullYear();

  month = month.toString().length === 1 ? month.toString().padStart(2, 0) : month

  return `${year}-${month}-${day}`
}


export const downloadFile = (url, fileName) => {
  const a = document.createElement('a');
  a.href = url;
  a.target = '_blank';
  a.setAttribute('download', fileName);
  a.click();
}

export const createFileName = ({ fileName, extension }) => {
  const date = new Date();
  const d = date.getDate();
  let m = date.getMonth() + 1;
  m = m.toString().length === 1 ? m.toString().padStart(2, 0) : m.toString();
  const y = date.getFullYear().toString().substr(-2);
  const h = date.getHours();
  const min = date.getMinutes();
  const sec = date.getSeconds();
  const miliSec = date.getMilliseconds();

  return `${fileName}_${y}${m}${d}${h}${min}${sec}${miliSec}${extension}`

}

export const getFileExt = (fileName) => fileName.slice(fileName.lastIndexOf('.'))

export function getCourseFolder(numberOfDigit, courseId) {
  let x = numberOfDigit - courseId.length;
  if (x > 0) {
    let folderName = courseId;
    for (let i = 1; i <= x; i++) {
      folderName = "0" + folderName;
    }
    return `Courses/Course_${folderName}`;
  }
  return `Courses/Course_${courseId}`;
}

export const convertToMs = (t) => {
  let ms = ''
  const [h, m, s = 0] = t.split(":")
  if (t) {
    ms = (Number(h) * 60 * 60 + Number(m) * 60 + Number(s)) * 1000;
  }
  return ms
}

export function msToTime(duration) {
  var milliseconds = parseInt((duration % 1000) / 100),
    seconds = Math.floor((duration / 1000) % 60),
    minutes = Math.floor((duration / (1000 * 60)) % 60),
    hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

  hours = (hours < 10) ? "0" + hours : hours;
  minutes = (minutes < 10) ? "0" + minutes : minutes;
  seconds = (seconds < 10) ? "0" + seconds : seconds;

  return hours + ":" + minutes + ":" + seconds + "." + milliseconds;
}

export function secondsToHms(d) {
  d = Number(d);
  var h = Math.floor(d / 3600);
  var m = Math.floor(d % 3600 / 60);
  var s = Math.floor(d % 3600 % 60);

  var hDisplay = h > 0 ? h + (h == 1 ? " hr " : " hrs ") : "";
  var mDisplay = m > 0 ? m + (m == 1 ? " min " : " mins ") : "";
  var sDisplay = s > 0 ? s + (s == 1 ? " sec" : " secs") : "";
  return hDisplay + mDisplay + sDisplay;
}

export const setStartDate = (startDate, startTime) => {
  const newDate = startDate?.split('/');
  const updatedDate = `${newDate[2]}/${newDate[1]}/${newDate[0]} ${startTime}`
  return updatedDate;
}

export const convertMsToHour = (time) => {
  let seconds = Math.floor((time / 1000) % 60);
  let minutes = Math.floor((time / (1000 * 60)) % 60);
  let hours = Math.floor((time / (1000 * 60 * 60)));

  return { seconds, minutes, hours };
}
export const convertMinutesToHour = (time) => {
  let minutes = Math.floor(time % 60);
  let hours = Math.floor(time / 60);

  return { minutes, hours };
}

export const formatDateToDDMMYY = (date) => {
  let newDateFormat = ''
  if (date) {
    const splitDate = date.split("-");
    const year = splitDate[0];
    const month = splitDate[1];
    const day = splitDate[2];
    newDateFormat = `${day}-${month}-${year}`
  }
  return newDateFormat;
}
export const formatDateToDDMMYYYY = (date) => {
  let newDateFormat = ''
  if (date) {
    const splitDate = date.split("-");
    const year = splitDate[0];
    const month = splitDate[1];
    const day = splitDate[2];
    newDateFormat = `${day}/${month}/${year}`
  }
  return newDateFormat;
}

export const formatDateToMMDDYYYY = (date) => {
  let newDateFormat = ''
  if (date) {
    const splitDate = date.split("-");
    const year = splitDate[0];
    const month = splitDate[1];
    const day = splitDate[2];
    newDateFormat = `${month}/${day}/${year}`
  }
  return newDateFormat;
}

export const trimWhiteSpace = (str) => {
  if (!!str) return str.trim();
  return false;
}

export const downloadFileFromBuffer = async (fileName, contentStreamReference) => {
  // const arrayBuffer = await contentStreamReference.arrayBuffer();
  const blob = new Blob([contentStreamReference]);
  const url = URL.createObjectURL(blob);
  const anchorElement = document.createElement('a');
  anchorElement.href = url;
  anchorElement.download = fileName ?? '';
  anchorElement.click();
  anchorElement.remove();
  URL.revokeObjectURL(url);
}

export function Base64ToBytes(base64) {
  const s = window.atob(base64);
  const bytes = new Uint8Array(s.length);
  for (let i = 0; i < s.length; i++) {
    bytes[i] = s.charCodeAt(i);
  }
  return bytes;
};


export function generatePassword1(length) {
  const chars = "ABCDEFGHJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*?_-"
  let password = '';
  for (let i = 0; i < length; i++) {
    const index = Math.floor(Math.random() * chars.length);
    password += chars[index];
  }
  return password;
}

export function generatePassword(length) {
  const smallLetters = 'abcdefghijklmnopqrstuvwxyz';
  const capitalLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const numbers = '0123456789';
  const specialChars = '!@#$%^&*?_-';
  const allChars = smallLetters + capitalLetters + numbers + specialChars;

  // Ensure password contains at least one of each type of character
  let password = [
    getRandomChar(smallLetters),
    getRandomChar(capitalLetters),
    getRandomChar(numbers),
    getRandomChar(specialChars),
  ];

  // Fill the rest of the password with random characters
  for (let i = 4; i < length; i++) {
    password.push(getRandomChar(allChars));
  }

  // Shuffle the password to avoid the first characters always being in the same character type order
  password = shuffleArray(password);

  return password.join('');
}

function getRandomChar(chars) {
  return chars.charAt(Math.floor(Math.random() * chars.length));
}

function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}


export const errorHandler = (error, data, url) => {
  if (error?.response?.status === 500) {
    ToastError("Something went wrong. Please try again after sometime!!");
    // } else {
    //   errorData({ err, data, url });
    //   ToastError("Something went wrong. Please try again after sometime!!");
  } else if (error.response?.status === 413) {
    ToastError('File too large. Please reduce the size and try again.');
  } else if (error.response) {
    ToastError(`Server error: ${error.response?.status || ''}`);
  } else if (error.request) {
    ToastError('No response from server.');
  } else {
    ToastError(`Unexpected error: ${error?.message}`);
  }
}

export const errorData = async ({ err, data, url }) => {
  const eData = {
    service: url,
    message: err?.message || "",
    logType: LOG_TYPE.Error,
    body: data ? JSON.stringify(data) : "",
  }
  try {
    // const response = await axios.post(`${NOTIFICATION_SERVICE}/Log/AddLog`, eData);
    // return response.data;
  } catch (err) {
    return err;
  }
}
export const suffix_of = (i) => {
  let j = i % 10,
    k = i % 100;
  if (j === 1 && k !== 11) {
    return i + "st";
  }
  if (j === 2 && k !== 12) {
    return i + "nd";
  }
  if (j === 3 && k !== 13) {
    return i + "rd";
  }
  return i + "th";
}

export const dateFormat = (date) => {
  const [startDateTime, startTime] = date?.split("T");
  const EDate = new Date(`${startDateTime} ${startTime}`)
  const newDate = moment(EDate).format("DD/MM/YYYY")
  const newTime = moment(EDate).format("hh:mm a")
  return { newDate, newTime }
}

export const getNextDay = (dayName) => {

  // The current day
  var date = new Date();
  var now = date.getDay();

  // Days of the week
  var days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

  // The index for the day you want
  var day = days.indexOf(dayName.toLowerCase());

  // Find the difference between the current day and the one you want
  // If it's the same day as today (or a negative number), jump to the next week
  var diff = day - now;
  diff = diff < 1 ? 7 + diff : diff;

  // Get the timestamp for the desired day
  var nextDayTimestamp = date.getTime() + (1000 * 60 * 60 * 24 * diff);

  // Get the next day
  return new Date(nextDayTimestamp);

};

export const validateAadharNumber = (val) => {
  return (/^[0-9]{12}$/).test(val);
}
export const validateNumber = (mobile) => {
  return (/^[0-9]{10}$/).test(mobile);
}

const COI_SW_PATH = "/coi-serviceworkers.js";

export function registerCoiServiceWorker() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register("/coi-serviceworkers.js")
      .then((registration) => {
        console.log("COI Service Worker registered", registration.scope);
      })
      .catch((err) => {
        console.error("COI Service Worker registration failed:", err);
      });
  } else {
    console.warn("Service Workers not supported in this browser.");
  }
}

export const unregisterCoiServiceWorker = async () => {
  if ("serviceWorker" in navigator) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (let reg of registrations) {
        if (reg.active?.scriptURL.includes(COI_SW_PATH)) {
          await reg.unregister();
          console.log("COI Service Worker unregistered");
        }
      }
    } catch (err) {
      console.error("Error while unregistering COI Service Worker:", err);
    }
  }
};


export const browerName = () => {
  let userAgent = navigator.userAgent;

  let browserName;

  if (userAgent.match(/chrome|chromium|crios/i)) {
    browserName = "chrome";
  } else if (userAgent.match(/firefox|fxios/i)) {
    browserName = "firefox";
  } else if (userAgent.match(/safari/i)) {
    browserName = "safari";
  } else if (userAgent.match(/opr\//i)) {
    browserName = "opera";
  } else if (userAgent.match(/edg/i)) {
    browserName = "edge";
  } else {
    browserName = "Unknown browser";
  }
  return browserName;
};

export const generateBase64Token = () => {
  // expiry = UTC + 5 minutes
  const expireTime = new Date(Date.now() + 5 * 60000);

  // format: MM/dd/yyyy HH mm
  const formatted = `${String(expireTime.getUTCMonth() + 1).padStart(2, "0")}/` +
    `${String(expireTime.getUTCDate()).padStart(2, "0")}/` +
    `${expireTime.getUTCFullYear()} ` +
    `${String(expireTime.getUTCHours()).padStart(2, "0")} ` +
    `${String(expireTime.getUTCMinutes()).padStart(2, "0")}`;

  // combine
  const tokenString = `${jwtTokenKey}:${formatted}`;

  // base64 encode
  return btoa(new TextEncoder().encode(tokenString).reduce((data, byte) => data + String.fromCharCode(byte), ""));
}

export function generateSecureToken(length = 32) {
  // Generate random bytes
  const random = CryptoJS.lib.WordArray.random(length);
  return random.toString(CryptoJS.enc.Hex).slice(0, length);
}

export const onKeyDownNumeric = (e) => {
  // 1. Allow Ctrl/Cmd key combinations (Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X, Ctrl+Z, etc.)
  if (e.ctrlKey || e.metaKey) {
    return;
  }

  // 2. Allow Navigation, Backspace, Delete, and Tab keys
  const allowedKeys = [
    "Backspace",
    "Delete",
    "Tab",
    "ArrowLeft",
    "ArrowRight",
    "Home",
    "End",
  ];

  // 3. Allow numeric digits 0-9
  const isDigit = /[0-9]/.test(e.key);

  // Prevent any key press that is NOT a digit or allowed key
  if (!isDigit && !allowedKeys.includes(e.key)) {
    e.preventDefault();
  }
}

export const formatDateForViewReport = (date) => {
  if (!date) return '-'
  return new Date(date).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const formatDateForInput = (date) => {
  if (!date) return "";
  const value = String(date).split("T")[0];
  const [year, month, day] = value.split("-");
  if (!year || !month || !day) return "";
  return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
};